import { render, staticRenderFns } from "./Laboratorio.vue?vue&type=template&id=c96c802a&scoped=true"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"
import style0 from "./Laboratorio.vue?vue&type=style&index=0&id=c96c802a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c802a",
  null
  
)

export default component.exports